import { cn } from '@wellesley/ui'
import CommonDialog from 'components/modals/CommonDialog'
import { FC, PropsWithChildren } from 'react'

import ModalContent from '../ModalContent'
import { TPostForm } from '../../PostForm/types'

type TFeedModal = PropsWithChildren & TPostForm

const FeedModal: FC<TFeedModal> = ({ isOpenModal, ...props }) => (
  <CommonDialog
    open={isOpenModal}
    showClose={false}
    className={cn(
      'left-0 top-0 h-[100vh] max-w-[100vw] translate-x-0 translate-y-0 rounded-none p-0 max-md:w-full',
    )}
  >
    <ModalContent {...props} />
  </CommonDialog>
)

export default FeedModal
